import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_TEAMMATE_DETAIL',
  'UPDATE_TEAMMATE',
  'DO_ACTION',
  // CUSTOM
  'SYNC_UPDATE_TEAMMATE_DETAIL'
);
